export default __webpack_public_path__ + "static/media/mw.8f7dfd51.svg";